import { createError } from '../../../../../lib/error';

class GuerrillaModalController {
  constructor(
    $scope,
    $rootScope,
    $uibModalInstance,
    $q,
    LogService,
    GeoService,
    VenueService,
    StaffUserService,
    DataSyncService,
    geolocation,
    translateFilter,
    moment,
    position,
    staffUser
  ) {
    "ngInject";
    this.$scope            = $scope;
    this.$rootScope        = $rootScope
    this.$uibModalInstance = $uibModalInstance;
    this.$q                = $q;
    this.LogService        = LogService;
    this.GeoService        = GeoService;
    this.VenueService      = VenueService;
    this.StaffUserService  = StaffUserService;
    this.DataSyncService   = DataSyncService;
    this.geolocation       = geolocation;
    this.translateFilter   = translateFilter;
    this.moment            = moment;
    this.parentPosition    = position;
    this.staffUser         = staffUser;

    this._errors           = [];
    this._location         = null;
    this._GPSStatusMessage = false;
    this._placesLoading    = false;
    this.accordions        = {
      locationSearch: true,
      locationSearchSelection: false
    };
    // Used as a marker to prevent reloading from Places result when selecting the tab if result exists.
    this._coordinatesOfPlaceSearchResult = false;

    this.lat  = false;
    this.lng = false;

    this._eventDatePickerOptions = {minDate: null, maxDate:null};

    this.guerrillaForm = {};
    this.guerrillaForm.start_time = new Date().setHours(9,0,0);
    this.guerrillaForm.end_time = new Date().setHours(17,0,0);
    this.guerrillaForm.venueSearch = {};
    this.guerrillaForm.venueSearch.nearbyOnly = true; // Default state when searching for venues
  }

  $onInit() {
    this.GPSStatusMessage = "GETTING_GPS_LOCATION";

    this.geolocation.getLocation()
      .then((data) => {
        this.lat = data.coords.latitude;
        this.lng = data.coords.longitude;
        this.GeoService.latLngLookup(this.lat + ',' + this.lng)
          .then((response) => {
            this.GPSStatusMessage = false;
            this._location = response.data.results[0].formatted_address;
          });

        // In case the user was on the tab but had no GPS and now it activates
        // this fires the lookup
        if (this.guerrillaForm.event_type && this._coordinatesOfPlaceSearchResult !== (this.lat + ',' + this.lng)) {
          this.doPlacesLookup();
        }
      })
      .catch(() => {
        this.GPSStatusMessage = "GPS_LOCATION_FAILED";
      });

    const program = this.staffUser.programs.find((el) => {
      return parseInt(el.id) === parseInt(this.parentPosition.programs_id);
    });
    this.program = program;

    const availableEventTypes = program.event_types.filter((el) => {
      return ( el.child_type );
    })

    this.availableEventTypes = availableEventTypes;
    // If only one event type is available then this is the one that must be used.
    if (availableEventTypes.length === 1) {
      this.guerrillaForm.event_type = availableEventTypes[0];
    }

    // Determine the available recap definitions

    let recapDefinitions = program.recap_definitions.filter((el) => {
      const minDate = new Date(Math.max.apply(null, [new Date(program.start_date), new Date(el.recap_available_events_start_time)]));
      const maxDate = new Date(Math.min.apply(null, [new Date(program.end_date), new Date(el.recap_available_events_end_time)]));
      const d = new Date();
      return (d.getTime() >= minDate.getTime() && d.getTime() <= maxDate.getTime());
    });

    this.availableRecapDefinitions = recapDefinitions;
    if (recapDefinitions.length === 1) {
      this.guerrillaForm.recap_definition = this.availableRecapDefinitions[0];
    }

    this.guerrillaForm.parent = this.parentPosition;

    this.guerrillaForm.event_date = this.parentPosition.event.start_timestamp

    this.updateDateLimits();
  }

  updateDateLimits() {
    const program_start_date = this.program.start_date;
    const program_end_date = this.program.end_date;

    let minDate = new Date(Math.max.apply(null, [new Date(program_start_date)]));
    let maxDate = new Date(Math.min.apply(null, [new Date(program_end_date)]));

    if (this.guerrillaForm.recap_definition) {
      const recap_start_date = this.guerrillaForm.recap_definition.recap_available_events_start_time;
      const recap_end_date = this.guerrillaForm.recap_definition.recap_available_events_end_time;

      minDate = new Date(Math.max.apply(null, [new Date(program_start_date), new Date(recap_start_date)]));
      maxDate = new Date(Math.min.apply(null, [new Date(program_end_date), new Date(recap_end_date)]));
    } else {
      if (this.parentPosition.event.recapDefinition) {
        const recap_start_date = this.parentPosition.event.recapDefinition.recap_available_events_start_time;
        const recap_end_date = this.parentPosition.event.recapDefinition.recap_available_events_end_time;

        minDate = new Date(Math.max.apply(null, [new Date(program_start_date), new Date(recap_start_date)]));
        maxDate = new Date(Math.min.apply(null, [new Date(program_end_date), new Date(recap_end_date)]));
      }
    }

    this._eventDatePickerOptions = { minDate: minDate, maxDate: maxDate };
  }

  get location() {
    return this._location;
  }

  set eventDatePickerOpened(opened) {
    this._eventDatePickerOpened = opened;
  }

  get placesLoading() {
    return this._placesLoading;
  }

  set placesLoading( val ) {
    this._placesLoading = val;
  }

  get eventDatePickerOpened() {
    return this._eventDatePickerOpened;
  }

  set eventDatePickerOptions(val) {
    this._eventDatePickerOptions = val;
  }
  get eventDatePickerOptions() {
    return this._eventDatePickerOptions;
  }

  set GPSStatusMessage( message ) {
    if (!message) {
      this._GPSStatusMessage = '';
    } else {
      this._GPSStatusMessage = this.translateFilter( message );
    }
  }

  get GPSStatusMessage() {
    return this._GPSStatusMessage;
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  placesLookup() {
    // If the event type changes the available google places types may also change and must reload
    if (!this.eventTypeWatcherExists) {
      this.$scope.$watch(
        (scope) => {
          return this.guerrillaForm.event_type;
        },
        () => {
          this.LogService.info('Event Type changed - reload places');
          this.doPlacesLookup();
        }
      );
      this.eventTypeWatcherExists = true;
    }

    this.geolocation.getLocation().then((data) => {
      this.LogService.log("Got location: " + data.coords.latitude + "," + data.coords.longitude);
      if (data.coords.latitude !== this.lat || data.coords.longitude !== this.lng) {
        this.lat = data.coords.latitude;
        this.lng = data.coords.longitude;
        this.LogService.log("Updating app lat and lng: " + this.lat + "," + this.lng);
        this.doPlacesLookup();
      }
    });
  }

  doPlacesLookup() {
    this.LogService.info("Places lookup for " + this.lat + "," + this.lng);

    // No lat and lng?  Watch for those to become available.
    if (!(this.lat === this.lng) && !this.coordinatesWatcherExists) {
      this.LogService.warn("Undefined latitude and logitude - location lookup aborted: " + this.lat + "," + this.lng);
      this.$scope.$watch(
        () => {
          return !!this.lat && !!this.lng;
        },
        () => {
          this.doPlacesLookup();
        }
      );
      this.coordinatesWatcherExists = true;
      return;
    }

    if (this.placesLoading > 0 || !this.lat || !this.lng) {
      return;
    }

    this.placesList = false;
    const googlePlacesEnabled = this.googlePlacesEnabled();
    this.placesLoading = googlePlacesEnabled ? 2 : 1;

    if (googlePlacesEnabled) {
      this.GeoService.placeSearch( this.lat +','+ this.lng,
        this.guerrillaForm.event_type.google_place_types, this.staffUser.profile.units )
        .then((response) => {
          this.placesList = response.data;
          this.placesLoading -= 1;
          // Set the search result coordinates flag with current location. This prevents
          // reloading from Places result when selecting the tab if result exists.
          this._coordinatesOfPlaceSearchResult = (this.lat + ',' + this.lng);
        })
        .catch(() => {
          console.error("No lookup - GPS failed");
        });
    }

    this.VenueService.nearbyVenueSearch( this.lat + ',' + this.lng,
      this.parentPosition.clients_id, 0.5)
      .then((response) => {
        this.nearbyPlacesList = response.data;
        this.placesLoading -= 1;
      }).
    catch(() => {
      this.LogService.log("No lookup - GPS failed");
    });
  }

  openEventDatePicker() {
    this.eventDatePickerOpened = true;
  }

  // Search for venues from the search input fields
  venueSearch() {
    const params = {
      street_address1: this.guerrillaForm.venueSearch.street_address1,
      venue_name: this.guerrillaForm.venueSearch.venue_name,
      state: this.guerrillaForm.venueSearch.state,
      city: this.guerrillaForm.venueSearch.city,
      zip: this.guerrillaForm.venueSearch.zip,
      lat: this.lat,
      lng: this.lng,
      nearby: this.guerrillaForm.venueSearch.nearbyOnly,
      clients_id: this.parentPosition.clients_id,
    };

    this.VenueService.venueSearch(params)
      .then((response) => {
        this.venueSearchResults = response.data.venues;
        this.accordions.locationSearch = false;
      })
      .catch(() => {
        this.LogService.error("Error searching for venues");
      });
  }

  // Selecting a Google place result triggers a lookup on the place id.
  selectGooglePlaceResult(value) {
    // If the user clicked on a place result that was already in the nearby venues list
    // pulled from the database that's what they should be seeing
    let venueFromNearbyList = this.nearbyPlacesList.venues.find((el) => {
        return String(el.place_id) === String(value.place_id);
      });
    if (!!venueFromNearbyList) {
      this.selectedSearchVenue = venueFromNearbyList;
      return;
    }

    // Google Place results don't have full info, the API has to be queried for details
    this.GeoService.placeDetail(value.place_id)
      .then((response) => {
        let place = response.data.result;

        // Response fields are not consistently organized, so we have to search for the components
        let street_number = place.address_components.find((val) => {
          return (val.types.indexOf('street_number') > -1);
        });
        let street = place.address_components.find((val) => {
          return (val.types.indexOf('route') > -1);
        });
        let city = place.address_components.find((val) => {
          return (val.types.indexOf('locality') > -1);
        });
        let state = place.address_components.find((val) => {
          return (val.types.indexOf('administrative_area_level_1') > -1);
        });
        let zip = place.address_components.find((val) => {
          return (val.types.indexOf('postal_code') > -1);
        });

        let street_address1 = '';
        if (street_number) {
          street_address1 += street_number.short_name + " ";
        }
        if (street) {
          street_address1 += street.short_name;
        }

        this.selectedSearchVenue = {
          venue_name: place.name,
          street_address1: street_address1,
          city: city.long_name,
          state: state.short_name,
          zip: zip.short_name,
          place_id: value.place_id
        }
      });
  }

  selectSearchVenue(value) {
    this.selectedSearchVenue = value;
  }
  selectYourLocationResult(value) {
    this.selectedSearchVenue = value;
  }

  cancelVenueSelection() {
    this.selectedSearchVenue = false;
  }

  getVenueTypesForProgram() {
    if (!this.parentPosition.programs_id) {
      return [];
    }
    const clientId = this.parentPosition.clients_id;
    const client = this.staffUser.clients.find((el) => String(el.id) === String(clientId));
    return client.venue_types;
  }

  // Whether the client allows Google places in the nearby search.
  googlePlacesEnabled() {
    const clientId = this.parentPosition.clients_id;
    const client = this.staffUser.clients.find((el) => String(el.id) === String(clientId));
    return !!(client && client.staff_can_search_nearby_google_places);
  }

  getMarketsForProgram() {
    if (!this.parentPosition.programs_id) {
      return [];
    }

    const clientId = this.parentPosition.clients_id;
    const client = this.staffUser.clients.find((el) => String(el.id) === String(clientId));
    return client.markets;
  }

  canDisplaySection(section) {
    switch(section) {
      case 'save':
        return (this.selectedSearchVenue && this.selectedSearchVenue.markets_id && this.selectedSearchVenue.venues_types_id);
      case 'add address':
        return (
          this.guerrillaForm.venue
          && this.guerrillaForm.venue.venue_name
          && this.guerrillaForm.venue.street_address1
          && this.guerrillaForm.venue.city
          && this.guerrillaForm.venue.state
          && this.guerrillaForm.venue.venues_types_id
          && this.guerrillaForm.venue.markets_id
        );
    }
  }

  // Takes the address in the 'new address' tab and sets it as the selected venue
  addAddress() {
    this.selectedSearchVenue = this.guerrillaForm.venue;

    const venueTypes = this.getVenueTypesForProgram();
    const venueType = venueTypes.find((val) => {
      return String(val.id) === String(this.guerrillaForm.venue.venues_types_id);
    });
    this.selectedSearchVenue.venues_types_name = venueType.name;

    const markets = this.getMarketsForProgram();
    const market = markets.find((val) => {
      return String(val.id) === String(this.guerrillaForm.venue.markets_id);
    });
    this.selectedSearchVenue.markets_name = market.name;

  }

  // Save the guerrilla event - we're all done!
  save() {
    this.guerrillaForm.venue = this.selectedSearchVenue;

    // We don't want time in UTC, it's local to the event
    this.guerrillaForm.start_time_formatted = this.moment(this.guerrillaForm.start_time).format('h:mm a');
    this.guerrillaForm.end_time_formatted = this.moment(this.guerrillaForm.end_time).format('h:mm a');
    this.guerrillaForm.event_date = this.moment(this.guerrillaForm.event_date).format('L');

    const guerrillaFormData = this._serializeGuerrillaFormForSave(this.guerrillaForm);
    this.StaffUserService.saveGuerrillaStop(guerrillaFormData)
      .catch((response) => {
        if (!response.success) {
          // Do something here to handle errors
          this.LogService.error(`Error saving guerrilla stop. Response:`, response, 'data:', guerrillaFormData);
          throw createError({
            error: 'ErrorSavingGuerrillaStop',
            description: 'An error occurred while saving guerrilla stop',
            response,
          })
        }
      })
      .then(response => {
        // There's only one position (it was created when the guerrilla stop was added) so this is
        // guaranteed to be the right one.
        const position = response;
        position.is_guerrilla = true;

        // Dismiss modal
        this.$uibModalInstance.dismiss('complete');

        // Refresh positions and then show recap response
        this.LogService.debug("guerrillaModal controller refreshing positions");
        this.DataSyncService.refreshPositions()
          .then(() => {
            // Show recap response for this position
            this.$rootScope.$emit('showRecapResponseForPosition', position);
          })
    });

  }

  _serializeGuerrillaFormForSave(form) {
    if (!form) {
      throw createError({
        error: 'MissingDataForGuerrillaEvent',
        description: 'Attempting to serialize empty data for guerrilla event',
      });
    }

    const parent = form.parent || null;
    if (!parent) {
      throw createError({
        error: 'MissingParentForGuerrillaEvent',
        description: 'Attempting to serialize guerrilla event with no parent',
      });
    }

    const eventTypeId = form.event_type && form.event_type.id;
    const recapDefinitionId = form.recap_definition && form.recap_definition.id;

    return {
      parent: {
        events_id: parent.events_id,
        clients_id: parent.clients_id,
        start_date: parent.start_date,
        programs_id: parent.programs_id,
        position_id: parent.position_id,
      },
      venue: form.venue,
      start_time_formatted: form.start_time_formatted,
      end_time_formatted: form.end_time_formatted,
      event_date: form.event_date || null,
      event_type: {
        id: eventTypeId,
      },
      event_name: form.event_name,
      description: form.description,
      recap_definition: {
        id: recapDefinitionId,
      },
    };
  }
}

export default GuerrillaModalController;

